define('constant/myaccount/settlement.constant',[], function () {
    var rs = {
        'billStatus': {
            // 应付-收益 AP
            'AP': {
                'C010': '待确认',
                'D010': '争议中',
                'D020': '争议待确认',
                'C020': '付款中',
                'P010': '付款中',
                'P020': '付款中',
                'P030': '付款中',
                'P040': '付款中',
                'P050': '付款成功'
            },
            // 应收-账单 AR
            'AR': {
                'C010': '待确认',
                'D010': '争议中',
                'D020': '争议待确认',
                'C020': '开票中',
                'I020': '开票中',
                'I030': '已开票',
                'I040': '已开票',
                'I050': '已开票',
                'I061': '已开票',
                'I062': '已开票'

            }
        },
        //应收、应付结算单状态下拉框
        'billStatusSelector': {
            // 应收-账单 AR
            'AR': [
                {
                    statusName: "全部",
                    statusCode: ['developer']
                },
                {
                    statusName: "待确认",
                    statusCode: ['C010']
                }, {
                    statusName: "争议中",
                    statusCode: ['D010']
                }, {
                    statusName: "争议待确认",
                    statusCode: ['D020']
                }, {
                    statusName: "开票中",
                    statusCode: ['I020', 'C020']
                }, {
                    statusName: "已开票",
                    statusCode: ['I030', 'I040', 'I050', 'I061', 'I062']
                }
            ],
            // 应付-收益 AP
            'AP': [
                {
                    statusName: "全部",
                    statusCode: ['developer']
                },
                {
                    statusName: "争议中",
                    statusCode: ['D010']
                },
                {
                    statusName: "待确认",
                    statusCode: ['C010']
                }, {
                    statusName: "付款中",
                    statusCode: ['C020', 'P010', 'P020', 'P030', 'P040']
                },
                {
                    statusName: "争议待确认",
                    statusCode: ['D020']
                },
                {
                    statusName: "付款成功",
                    statusCode: ['P050']
                }
            ]
        },


        //应收、应付业务类型下拉框
        'businessSelector': {
            // 应收-账单 AR
            'AR': [
                {
                    typeName: "全部",
                    typeCode: "-1"
                }
            ],
            // 应付-收益 AP
            'AP': [
                {
                    typeName: "全部",
                    typeCode: "-1"
                }
            ]
        },


        'settleReturnDesc': {
            'success': 0 //成功返回码
        },

        'currencyType': {
            'CNY': '人民币',
            'USD': '美元',
            'EUR': '欧元',
            'JPY': '日元',
            'HKD': '港元',
            'GBP': '英镑',
            "AED": "阿联酋迪拉姆",
            "AUD": "澳元",
            "CAD": "加拿大元",
            "CHF": "瑞士法郎",
            "DKK": "丹麦克朗",
            "IDR": "印度尼西亚盾",
            "INR": "印度卢比",
            "MXN": "墨西哥比索",
            "MYR": "马来西亚林吉特",
            "NOK": "挪威克朗",
            "NZD": "新西兰元",
            "PHP": "菲律宾比索",
            "RUB": "俄罗斯卢布",
            "SEK": "瑞典克朗",
            "SGD": "新加坡元",
            "THB": "泰国铢",
            "ZAR": "南非兰特"
        },
        'statusMap': {//允许确认结算单的结算单状态集合
            // 应收-账单 AR
            'AR': {
                'C010': true, //待确认,
                'D010': false, //争议中,
                'D020': true, //争议待确认,
                'I020': false, //开票中,
                'I030': false //已开票
            },
            // 应付-收益 AP
            'AP': {
                'C010': true, //待确认'
                'D010': false,//争议中'
                'D020': true, //争议待确认,
                'P030': false,//付款中'
                'P040': false,//付款中'
                'P050': false //付款成功
            }
        },
        'statusMapForDispute': {   //允许申请争议单的结算单状态集合
            // 应收-账单 AR
            'AR': {
                'C010': true, //待确认,
                'D020': true, //争议待确认,
                'D010': false, //争议中,
                'I020': false, //开票中,
                'I030': false //已开票
            },
            // 应付-收益 AP
            'AP': {
                'C010': true, //待确认'
                'D020': true, //争议待确认,
                'D010': false,//争议中'
                'P030': false,//付款中'
                'P040': false,//付款中
                'P050': false //付款成功
            }
        },
        'disputeReasons': {
            'AR': [// 应收-账单 AP
                {
                    'code': 'rule',
                    'desc': '结算规则错误'
                },
                {
                    'code': 'statistics',
                    'desc': '消耗统计有误'
                },
                {
                    'code': 'information',
                    'desc': 'CP信息错误'
                },
                {
                    'code': 'other',
                    'desc': '其它'
                }
            ],
            'AP': [// 应付-收益 AP
                {
                    'code': 'rule',
                    'desc': '结算规则错误'
                },
                {
                    'code': 'statistics',
                    'desc': '业务订单错误'
                },
                {
                    'code': 'information',
                    'desc': 'CP信息错误'
                },
                {
                    'code': 'other',
                    'desc': '其它'
                }
            ]
        },
        'payType': {//付款方式
            'AP': '银行转账',
            'AR': ['现金', '资源置换']
        },
        'payChannel': {
            '1': '银行卡',
            '2': '零钱',
            '3': '花币',
            '4': '支付宝',
            '5': '微信支付',
            '6': '神州付（手机充值卡）',
            '7': '优惠券',
            '8': '手机话费',
            '0': '其他'
        },
        'rPCode': {
            'P001': '收到发票后10个工作日',
            'P002': '收到发票后15个工作日',
            'P003': '收到发票后15个自然日',
            'P004': '收到发票后20个工作日',
            'P005': '收到发票后20个自然日',
            'P006': '收到发票后30个工作日',
            'P007': '收到发票后30个自然日',
            'P008': '收到发票后3个工作日',
            'P009': '收到发票后45个自然日',
            'P010': '收到发票后60个自然日',
            'P011': '收到发票后90个自然日',
            'P012': '收到发票后120个自然日',
            'P013': '收到发票后21个自然日',
            'P014': '30天内付款',
            'P015': 'COD',
            'P016': '收到发票后28个自然日',
            'P017': '5日前收票+1月月底付款，5日后+2月底付款',
            'P018': '20日前收票+1月月底付款，20日后+2月底付款',
            'P019': '25日前收票+1月月底付款，25日后+2月底付款',
            'P020': '开具发票后30个自然日',
            'P021': '开具发票后45个自然日',
            'P022': '开具发票后60个自然日',
            'P023': '收到发票后5个工作日',
            'P024': '收到发票后10个自然日',
            'P025': '确认结算单后30个自然日',
            'P026': '收到发票后180个自然日'
        },
        'HistoryNodeInfo': {
            settlement: {
                AR: {
                    C010: '结算单生成待确认',
                    D010: '提交结算单争议',
                    D020: '结算单争议已处理',
                    C020: '确认结算单',
                    I020: '发起结算单开票',
                    I030: '结算单开票完成'

                },
                AP: {
                    C010: '结算单生成待确认',
                    D010: '提交结算单争议',
                    D020: '结算单争议已处理',
                    C020: '确认结算单',
                    P040: '发起结算单付款',
                    P050: '结算单付款完成'
                }
            },
            dispute: {
                0: '争议申请已提交',
                1: '争议申请已处理',
                2: '争议申请已撤销',
                3: '争议申请已驳回并关闭'
            }
        },
        disputeReasonsMap: {//争议原因
            AR: {
                'rule': '结算规则错误',
                'statistics': '消耗统计有误',
                'information': 'CP信息错误',
                'other': '其它'
            },
            AP: {
                'rule': '结算规则错误',
                'statistics': '业务订单错误',
                'information': 'CP信息错误',
                'other': '其它'
            }
        },
        dispute: {
            0: '审核中',
            1: '已处理',
            2: '已撤销',
            3: '已驳回并关闭'
        },

        signEntityNameMap: {
            '0041': '华为软件技术有限公司',
            '0971': '华为终端有限公司',
            '1321': '华为终端（香港）',
            '1351' :'华为服务(香港)有限公司',
            '1731': '阿斯比格欧洲股份有限公司',
            '4001':'南非华为技术有限公司',
            '4021': '尼日利亚华为技术有限公司',
            '0021': '华为技术有限公司',
            '1061': '菲律宾华为技术有限公司',
            '1041':'新加坡华为技术有限公司',
            '4141': '阿尔及利亚华为电讯有限公司',
            '1021': '华为技术巴基斯坦（私有）有限公司',
            '1031': '华为技术（马来西亚）有限公司',
            '1091': 'PT华为技术投资有限公司',
            '4181': '南非BEE合资有限责任公司',
            '1591': '华为技术科威特有限责任公司',
            '1011': '沙特华为技术有限公司',
            '4261': '华为加纳技术有限公司',
            '1451': '华为技术仰光有限公司',
            '1241': '华为国际有限公司'
        },
        //0本国的银行卡1外国的银行卡
        signEntityBankMap: {
            '0041': '0',
            '0971': '0',
            '0021': '0',
            '1731': '1',
            '1011': '1',
            '1021': '1',
            '1031': '1',
            '1061': '1',
            '1091': '1',
            '1241': '1',
            '1321': '1',
            '1451': '1',
            '1591': '1',
            '4021': '1',
            '4141': '1',
            '4181': '1',
            '4261': '1',
            '1351': '1'
        },

        hiddenTaxReceiptTypeSignEntity: '0041',

        'showSelfBilling': {
            'AP': true,
            'AR': true
        }
    };
    //sysParamCfg先加载
    rs.businessType = sysParamCfg.businessType;
    //此方法主要是赋值，另外过滤掉查询条件下拉列表中的云文件夹推广、应用市场推广 两个值
    function assignType(type) {
        var tarArr = rs.businessSelector[type];
        var obj = rs.businessType[type];
        if (!obj) {
            return;
        }
        //过滤掉应文件夹推广、应用市场推广的条件,和之前保持一致
        if ('AR' == type) {
            var tmp = {};
            for (var idx in obj) {
                if (idx != 22 && idx != 51) {
                    tmp[idx] = obj[idx];
                }
            }
            obj = tmp;
        }
        var keys = Object.keys(obj);
        for (var keysKey in keys) {
            var k = keys[keysKey];
            var newObj = {'typeCode': k, 'typeName': obj[k]};
            tarArr.push(newObj);
        }
    }

    //补充产品映射
    //账单查询条件没有推广
    assignType('AR');
    assignType('AP');

    return rs;
});

